import {
  DashboardOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons';


import { faAddressCard, faCalendarDay, faDollarSign, faFileInvoiceDollar, faGaugeHigh, faInbox, faMapLocation, faMoneyCheckDollar, faRoute, faRulerTriangle, faScrewdriverWrench, faSquareDollar, faTruckClock, faUserHelmetSafety } from '@fortawesome/pro-light-svg-icons'

import { faObjectsColumn, faMessageLines, faLocationDot, faUser, faUserGroup, faChartLine } from '@fortawesome/pro-regular-svg-icons'

const dashBoardNavTree = [{
  key: 'dashboard',
  path: '/dashboard',
  title: 'app.nav.dashboard',
  icon: faObjectsColumn,
  breadcrumb: false,
  submenu: []
}, {
  key: 'calendar',
  path: '/calendar',
  title: 'app.nav.schedule',
  icon: faMessageLines,
  breadcrumb: false,
  submenu: [{
    key: 'calendar',
    path: '/calendar',
    title: 'app.nav.calendar',
    icon: faCalendarDay,
    breadcrumb: false,
    submenu: []
  },{
    key: 'dispatch',
    path: '/dispatch',
    title: 'app.nav.dispatch',
    icon: faTruckClock,
    breadcrumb: false,
    submenu: []
  },{
    key: 'routes',
    path: '/routes',
    title: 'app.nav.routes',
    icon: faRoute,
    breadcrumb: false,
    submenu: []
  }
  ]
},   {
  key: 'map',
  path: '/map',
  title: 'app.nav.map',
  icon: faLocationDot,
  breadcrumb: false,
  submenu: []

}, {
  key: 'contacts',
  path: '/calendar',
  title: 'app.nav.contacts',
  icon: faUser,
  breadcrumb: false,
  submenu: [{
    key: 'contacts',
    path: '/calendar',
    title: 'app.nav.contacts',
    icon: faUser,
    breadcrumb: false,
    submenu: []
  },{
    key: 'groups',
    path: '/dispatch',
    title: 'app.nav.groups',
    icon: faUserGroup,
    breadcrumb: false,
    submenu: []
  } 
  ]
},   {   
  key: 'clients',
  path: '/clients',
  title: 'app.nav.clients',
  icon: faAddressCard,
  breadcrumb: false,
  submenu: []
}, {
  key: 'requests',
  path: '/requests',
  title: 'app.nav.requests',
  icon: faInbox,
  breadcrumb: false,
  submenu: []
}, {
  key: 'quotes',
  path: '/quotes',
  title: 'app.nav.quotes',
  icon: faRulerTriangle,
  breadcrumb: false,
  submenu: []
}, {
  key: 'jobs',
  path: '/jobs',
  title: 'app.nav.jobs',
  icon: faScrewdriverWrench,
  breadcrumb: false,
  submenu: []
}, {
  key: 'invoices',
  path: '/invoices',
  title: 'app.nav.invoices',
  icon: faFileInvoiceDollar,
  breadcrumb: false,
  submenu: [] 
},{
  key: 'reports',
  path: '/reports',
  title: 'app.nav.reports',
  icon: faChartLine,
  breadcrumb: false,
  submenu: []
}]

const navigationConfig = [
  ...dashBoardNavTree
]

export default navigationConfig;
